import { render, staticRenderFns } from "./FTPCreator.vue?vue&type=template&id=7b80a74a"
import script from "./FTPCreator.vue?vue&type=script&lang=js"
export * from "./FTPCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports